/**
 * HEADER MAIN MENU
 *
 * @version 0.1
 */

import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, withRouter } from 'react-router';

import Logo from './Header.logo.jsx';
import SubMenu from './Header.subMenu.jsx';
import UploadsPending from './Header.uploadsPending.jsx';
import WhatsNew from './Header.whatsNew.jsx';
import ProductSwitcher from "./Header.productSwitcher.jsx";
import LanguageSelector from './../../../reusable/LanguageSelector/LanguageSelector.index.jsx'

import { userHas, permissions } from "../../../permissions";

function MainMenu({ user, menuStateClass, subMenuMessage, values, helpUrl, router }) {

    const subMenuItem = subMenuMessage ? <SubMenu messageId={subMenuMessage} values={values}/> : <div className="submenu no-print" />;
    let mainMenuNav = null;

    if (user.isLoggedIn) {
        let uploadsHeaderClass = 'header__menu-link uploads';
        let companiesHeaderClass = 'header__menu-link companies';
        let feedsHeaderClass = 'header__menu-link feeds';
        let alertsHeaderClass = 'header__menu-link alerts';

        switch(menuStateClass) {
            case 'uploads':
                uploadsHeaderClass = uploadsHeaderClass + ' active';
                break;
            case 'companies':
                companiesHeaderClass = companiesHeaderClass + ' active';
                break;
            case 'feeds':
                feedsHeaderClass = feedsHeaderClass + ' active';
                break;
            case 'alerts':
                alertsHeaderClass = alertsHeaderClass + ' active';
                break;
            default:
                break;
        }

        mainMenuNav = (
            <nav className="header__menu" id="nav-fragments">
                <ul className="no-print-hidden">
                <div className="header-menu-center">
                    {userHas(permissions.entities.edit) &&
                    <Fragment>
                        <li className="header__menu-item
                                               header__menu-item--upload">
                            <div className={uploadsHeaderClass}>
                                <FormattedMessage id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.uploads"/>

                                <UploadsPending pendingUpload={user.pendingUpload}/>

                                <span className="la-TriangleDown"></span>
                            </div>

                            <div className="dropdown-content
                                                        dropdown-content--upload">

                                <Link to="/review-companies"
                                      className="header__menu-link">
                                    <FormattedMessage id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.uploads.review"/>
                                </Link>

                                <Link to="/upload"
                                      className="header__menu-link ">
                                    <FormattedMessage
                                        id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.uploads.batchUpload"/>

                                    <UploadsPending pendingUpload={user.pendingUpload}/>

                                </Link>

                            </div>

                        </li>

                    </Fragment>
                    }

                    {userHas(permissions.entities) && userHas(permissions.categories) &&
                    <Fragment>
                        <li className="header__menu-item
                                                   header__menu-item--companies">

                            <div className={companiesHeaderClass}>
                                <FormattedMessage
                                    id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.entitiesAndCategories"/>
                                <span className="la-TriangleDown"></span>
                            </div>

                            <div className="dropdown-content dropdown-content--companies">
                                {userHas(permissions.entities) &&
                                <Fragment>
                                    <Link to="/manage-third-parties"
                                          className="header__menu-link">
                                        <FormattedMessage
                                            id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.companies.manageAllEntities"/>
                                    </Link>

                                    {userHas(permissions.entities.edit) &&
                                    <Link to='/create-new-entity'
                                          className="header__menu-link">
                                        <FormattedMessage
                                            id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.companies.createNewEntity"/>
                                    </Link>
                                    }
                                </Fragment>
                                }
                                {userHas(permissions.categories) &&
                                <Fragment>
                                    <Link to="/categories"
                                          className="header__menu-link">
                                        <FormattedMessage
                                            id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.companies.manageAllCategories"/>
                                    </Link>
                                    {userHas(permissions.categories.edit) &&
                                    <Link to="/create-category"
                                          className="header__menu-link">
                                        <FormattedMessage
                                            id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.companies.createNewCategory"/>
                                    </Link>
                                    }
                                </Fragment>
                                }
                            </div>

                        </li>

                    </Fragment>
                    }

                    {userHas(permissions.feeds) &&
                    <Fragment>
                        <li className="header__menu-item
                                               header__menu-item--feeds">

                            <div className={feedsHeaderClass}>
                                <FormattedMessage id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.feeds"/>
                                <span className="la-TriangleDown"></span>
                            </div>

                            <div className="dropdown-content
                                                    dropdown-content--feeds">

                                <Link to="/feeds"
                                      className="header__menu-link">
                                    <FormattedMessage id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.feeds.manage"/>
                                </Link>
                                {userHas(permissions.feeds.edit) &&
                                <Link to="/add-new-feed"
                                      className="header__menu-link">
                                    <FormattedMessage id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.feeds.create"/>
                                </Link>
                                }
                            </div>

                        </li>

                    </Fragment>
                    }

                    {
                        user.appSettings.isAlertsEnabled && userHas(permissions.alerts) &&
                            <Fragment>
                                <li className="header__menu-item
                                                       header__menu-item--alerts">

                                    <div className={alertsHeaderClass}>
                                        <FormattedMessage id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.alerts"/>
                                        <span className="la-TriangleDown"></span>
                                    </div>

                                    <div className="dropdown-content
                                                            dropdown-content--alerts">

                                        <Link to="/email-alerts"
                                              className="header__menu-link">
                                            <FormattedMessage id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.alerts.manage"/>
                                        </Link>
                                        {userHas(permissions.alerts.edit) &&
                                        <Link to="/create-new-alert"
                                              className="header__menu-link">
                                            <FormattedMessage
                                                id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.alerts.create"/>
                                        </Link>
                                        }
                                    </div>

                                </li>
                            </Fragment>
                    }
                    </div>
                    <div className="header-menu-right">
                        <WhatsNew userAppVersion={user.preferences.userAppVersion}
                                helpUrlRoot={user.helpUrlRoot} />

                        <li className="header__menu-item
                                            header__menu-item--user">

                            <div className="header__menu-link">
                                <span className="user-name notranslate" title={user.name}>{user.name}</span>
                                <span className="la-TriangleDown"></span>
                            </div>

                            <div className="dropdown-content
                                                    dropdown-content--user">
                                {
                                    user.appSettings.accountPageEnabled && userHas(permissions.admin) &&
                                        <Link to="/account" className="header__menu-link header__menu-link--admin">
                                            <FormattedMessage id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.user.adminPanel"/>
                                        </Link>
                                }
                                <a href={helpUrl}
                                target="_blank"
                                className="header__menu-link">
                                    <FormattedMessage id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.help"/>
                                    <span className="la-ExternalLink"></span>
                                </a>

                                <LanguageSelector />

                                <Link to="/logout?redirect=true" className="header__menu-link header__menu-link--logout">
                                    <FormattedMessage id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.user.signout"/>
                                </Link>

                            </div>

                        </li>
                    </div>
                </ul>
            </nav>
        );

    }

    return (
        <Fragment>
        <div className="header">
            <div className="header__menu-wrapper">
                <div className="header-menu-left">
                    <ProductSwitcher language = {user.preferences.language}
                                     products = {user.productAuthorizations} 
                    />
                    <Logo />
                </div>
                {mainMenuNav}
            </div>
        </div>
            {subMenuItem}
        </Fragment>
    );

}

export default withRouter(MainMenu);


// WEBPACK FOOTER //
// ./src/scripts/reusable/Header/templates/Header.mainMenu.jsx